import type { RouteRecordRaw } from 'vue-router';

export default {
  path: 'projects',
  name: 'projects',
  component: () => import('@/views/dashboard/projects/list.vue'),
} satisfies RouteRecordRaw;
